<template>
  <slide-over-right :id="sorId" v-on:showModal="showModal" editType="standard">
    <loading :active.sync="isLoading"></loading>

    <template v-slot:header>
      <h2 class="font-semibold text-gray-900 text-22px">
        Edit Geofence Settings
      </h2>
    </template>

    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submit)" class="px-6">
        <AppInput
          type="richselect"
          rules=""
          :name="
            $t(
              'components.settingsManagement.riderApp.geofenceConfigurations.edit.title.areaType'
            )
          "
          :label="
            $t(
              'components.settingsManagement.riderApp.geofenceConfigurations.edit.title.areaType'
            )
          "
          :placeholder="`Select one`"
          :options="areaTypes"
          :disabled="isEditing"
          hide-search-box
          v-model="form.area_type"
        />
        <AppInput
          v-model="form.title"
          type="text"
          rules=""
          :name="
            $t(
              'components.settingsManagement.riderApp.geofenceConfigurations.edit.title.title'
            )
          "
          :label="
            $t(
              'components.settingsManagement.riderApp.geofenceConfigurations.edit.title.title'
            )
          "
        />
        <AppInput
          v-model="form.description"
          type="textarea"
          rules=""
          :name="
            $t(
              'components.settingsManagement.riderApp.geofenceConfigurations.edit.title.description'
            )
          "
          :label="
            $t(
              'components.settingsManagement.riderApp.geofenceConfigurations.edit.title.description'
            )
          "
        />
        <AppInput
          v-model="form.color"
          type="color"
          rules=""
          :name="
            $t(
              'components.settingsManagement.riderApp.geofenceConfigurations.edit.title.color'
            )
          "
          :label="
            $t(
              'components.settingsManagement.riderApp.geofenceConfigurations.edit.title.color'
            )
          "
        />
        <AppInput
          type="richselect"
          rules=""
          :name="
            $t(
              'components.settingsManagement.riderApp.geofenceConfigurations.edit.title.status'
            )
          "
          :label="
            $t(
              'components.settingsManagement.riderApp.geofenceConfigurations.edit.title.status'
            )
          "
          :placeholder="`Select one`"
          :options="[
            { text: 'Active', value: true },
            { text: 'Inactive', value: false },
          ]"
          hide-search-box
          v-model="form.should_display"
        />
        <div>
          <label class="font-semibold leading-normal text-14px text-gray-700"
            >{{
              $t(
                'components.settingsManagement.riderApp.geofenceConfigurations.edit.title.introIcon'
              )
            }}
          </label>
          <UploadAvatar
            v-model="form.intro_icon"
            :current="form.intro_icon"
            :class="`mb-3`"
          />
        </div>
        <div>
          <label class="font-semibold leading-normal text-14px text-gray-700"
            >{{
              $t(
                'components.settingsManagement.riderApp.geofenceConfigurations.edit.title.markerIcon'
              )
            }}
          </label>
          <UploadAvatar
            v-model="form.marker_icon"
            :current="form.marker_icon"
            :class="`mb-3`"
          />
        </div>

        <div class="flex justify-end items-center mt-6">
          <slide-over-right-trigger :id="sorId">
            <anchor-button variant="secondary">{{
              $t('components.stepNavigation.cancel')
            }}</anchor-button>
          </slide-over-right-trigger>
          <t-button type="submit" class="ml-3">{{
            isEditing
              ? $t('components.stepNavigation.update')
              : $t('components.stepNavigation.save')
          }}</t-button>
        </div>
      </form>
    </ValidationObserver>
  </slide-over-right>
</template>

<script>
import xMan from '@/utils/xMan'
import { EventBus } from '@/utils/EventBus'
import { AreaSettingsConfig } from '@/config/AreaSettingsConfig'
import { useEndpoints } from '@/composables'
import { UploadAvatar } from '@/components/form'
export default {
  name: 'AddEditHardwareMessage',
  props: {
    messageTypes: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    SlideOverRight: () => import('@/components/modals/SlideOverRight'),
    SlideOverRightTrigger: () =>
      import('@/components/modals/SlideOverRightTrigger'),
    AnchorButton: () => import('@/components/form/AnchorButton.vue'),
    UploadAvatar,
  },
  data() {
    return {
      isLoading: false,
      item: {},
      form: {},
      errors: [],
      sorId: AreaSettingsConfig.events.sorId,
      areaTypes: [
        {
          text: 'Service Area',
          value: 'SERVICE_AREA',
        },
        {
          text: 'Restricted Area',
          value: 'RESTRICTED_AREA',
        },
        {
          text: 'Slow Speed Area',
          value: 'SLOW_ZONE_AREA',
        },
        {
          text: 'Public Parking Area',
          value: 'PUBLIC_PARKING_AREA',
        },
        {
          text: 'Private Parking Area',
          value: 'PRIVATE_PARKING_AREA',
        },
        {
          text: 'Rent Station Area',
          value: 'RENT_AREA',
        },
        {
          text: 'Reward Zone',
          value: 'REWARD_ZONE',
        },
        {
          text: 'Sunpod Area',
          value: 'SUN_POD_AREA',
        },
        {
          text: 'Priority Zone',
          value: 'PRIORITY_ZONE',
        },
      ],
    }
  },
  computed: {
    orgId() {
      return this.$store.getters['auth/organizationInfo'].id || null
    },
    isEditing: function() {
      return Object.keys(this.item).length !== 0
    },
    getTitleText() {
      return this.isEditing
        ? this.$t(
            'components.settingsManagement.riderApp.additionalMessages.addEdit.headline.edit'
          )
        : this.$t(
            'components.settingsManagement.riderApp.additionalMessages.addEdit.headline.add'
          )
    },
  },
  mounted() {
    EventBus.$on(AreaSettingsConfig.events.editingData, (item) => {
      this.item = item
      this.form = { ...this.item }
    })
  },
  methods: {
    showModal() {
      dispatchEvent(new Event(AreaSettingsConfig.events.sorToggle))
    },
    submit: async function() {
      this.isLoading = true
      let method = 'PATCH'
      let url = useEndpoints.settings.riderApp.updateAreaSettings(this.form.id)

      const formDataProxy = {
        ...this.form,
        title: this.form.title ?? '',
        description: this.form.description ?? '',
        color: `${this.form.color}`.split('#')[1],
      }

      if (
        typeof formDataProxy.intro_icon === 'string' ||
        formDataProxy.intro_icon == null
      ) {
        delete formDataProxy.intro_icon
      }

      if (
        typeof formDataProxy.marker_icon === 'string' ||
        formDataProxy.marker_icon === null
      ) {
        delete formDataProxy.marker_icon
      }

      let data = new xMan(formDataProxy).toFormData()
      let message = 'Area Settings updated successfully'

      try {
        let response = await this.$http({ method, url, data })
        this.isLoading = false
        // Close the slideover
        dispatchEvent(new Event(AreaSettingsConfig.events.sorClose))
        // Refetch the indexData
        dispatchEvent(new Event(AreaSettingsConfig.events.refresh))
        // Reset the form
        this.form = {}
        this.$notify(
          {
            group: 'generic',
            type: 'success',
            title: 'Success',
            text: message,
          },
          3000
        )
        // Resolved
        return response.status
      } catch (error) {
        console.log('area-settings-add-edit-err', { error })

        this.isLoading = false

        var errorData = Object.values(error.response.data)
        console.log(errorData)

        this.$notify(
          {
            group: 'generic',
            type: 'error',
            title: `Failed [${error.response.status}]`,
            text:
              error.response.status >= 500
                ? 'Failed to delete'
                : errorData[0][0],
          },
          3000
        )
      }
    },
  },
}
</script>

<style></style>
